<template>
  <lb-dialog
    v-model="internalValue"
    :loading="loading"
    :heading="heading"
    :width="width"
  >
    <template v-slot:body>
      <div>
        <div class="d-flex align-center">
          <div class="d-flex">
            <lb-dropdown
              hidedetails
              label="Year"
              :items="yearsList"
              :value="currentYear"
              itemtext="name"
              itemvalue="name"
              class="mr-2"
              @change="updateYear"
            ></lb-dropdown>
            <lb-dropdown
              hidedetails
              label="Period"
              :items="downloadPeriodList"
              :value="currentPeriod"
              itemtext="name"
              itemvalue="_id"
              @change="updatePeriod"
            ></lb-dropdown>
          </div>
          <v-spacer />
          <v-btn
            color="secondaryBtn"
            :disabled="!currentPeriod"
            @click="$emit('generate')"
          >
            <span>{{ generateLabel }}</span>
          </v-btn>
        </div>
        <lb-divider class="my-4" />
        <div v-if="!hasDownloads" class="title grey--text text--lighten-1 ma-4 text-center">{{ noDownloadsText }}</div>
        <div v-else>
          <h5 class="mb-2 font-weight-regular">Previous downloads</h5>
          <div class="hoverable" v-for="entry in downloads" :key="entry._id">
            <div class="d-flex align-center px-2 py-1">
              <div>{{ entry.period_detail.year }} - {{ entry.period_detail.month }}</div>
              <div class="caption-text ml-2 grey--text" style="font-size: 10px !important;">
                Requested on: {{ $nova.formatDateTime(entry.created_at) }}
              </div>
              <v-spacer />
              <v-tooltip bottom content-class="tooltip-bottom" v-if="entry.stage === 1">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn class="mx-0 px-0" icon v-bind="attrs" v-on="on" @click.stop="$emit('download', entry._id)">
                    <v-icon>mdi-download</v-icon>
                  </v-btn>
                </template>
                <span>Download</span>
              </v-tooltip>
              <v-chip v-if="entry.stage === 1" color="success" label><span>Ready</span></v-chip>
              <v-chip v-else-if="entry.stage === 0 || entry.stage === 4" color="info" label><span>Generating</span></v-chip>
              <div v-else>
                <v-chip color="error" label v-if="!entry.errormessage"><span>Failed</span></v-chip>
                <v-tooltip right content-class="tooltip-right" v-else>
                  <template v-slot:activator="{ on }">
                    <v-btn class="mx-3 px-0" icon v-on="on">
                      <v-chip color="error" label><span>Failed</span></v-chip>
                    </v-btn>
                  </template>
                  <span>{{ entry.errormessage }}</span>
                </v-tooltip>
              </div>
            </div>
            <lb-divider />
          </div>
        </div>
      </div>
    </template>
  </lb-dialog>
</template>

<script>
export default {
  name: 'RUCycleDownloadDialog',
  props: {
    value: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
    heading: { type: String, default: "RU Cycle Approval Reports" },
    width: { type: [Number, String], default: 600 },
    yearsList: { type: Array, default: () => [] },
    downloadPeriodList: { type: Array, default: () => [] },
    currentYear: { type: String, default: '' },
    currentPeriod: { type: String, default: '' },
    downloads: { type: Array, default: () => [] },
    generateLabel: { type: String, default: 'Generate' },
    noDownloadsText: { type: String, default: 'No downloads' },
  },

  computed: {
    internalValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      }
    },
    hasDownloads() {
      return this.downloads && this.downloads.length > 0;
    }
  },
  methods: {
    updateYear(value) {
      this.$emit('update:all-ru-download-year', value);
    },
    updatePeriod(value) {
      this.$emit('update:all-ru-download-period', value);
    }
  }
};
</script>
